import { queryOptions } from '@tanstack/react-query'

import { fetchProfile } from '#admin/features/account/api.ts'

export const profileQuery = () =>
  queryOptions({
    queryKey: ['identity', 'me', 'profile'],
    queryFn: ({ signal }) => fetchProfile(signal),
  })
